import { Injectable } from '@angular/core';
import { BehaviorSubject, catchError, map, of } from 'rxjs';
import { ApiService } from './api.service';
import { TokenService } from './token.service';
import { UserService } from './user.service';
import { FaviconService } from './favicon.service';
import { Company } from '../models/company.model';

@Injectable({
  providedIn: 'root'
})
export class AuthService {

  private loggedIn = new BehaviorSubject<boolean>(this.token.loggedIn());
  authStatus = this.loggedIn.asObservable();

  // login process info
  private loginProcessSubject = new BehaviorSubject<LoginProcessInfo>(null as any);
  loginProcess = this.loginProcessSubject.asObservable();

  constructor(private token:TokenService,
              private api:ApiService,
              private user:UserService,
              private favicon:FaviconService) { }

  loginOtp(otp:string, keepAlive:boolean = true) {
    return this.api.loginOtp(otp).pipe(
      map((response:any) => {
        // store user details and jwt token in local storage to keep user logged in between page refreshes
        if(response.user && response.access_token) {

          this.token.handle(response.access_token);
          this.user.setUser(response.user, keepAlive);
          this.changeAuthStatus(true);
        }

        return response;
      })
    );
  }

  logout() {
    // remove user from local storage to log user out
    this.token.remove();
    this.user.deleteUser();
    this.favicon.reset();
    this.changeAuthStatus(false);
  }

  refreshToken() {
    return this.api.refreshToken().pipe(
      map(response => {
        this.token.handle(response.access_token);
        this.user.setUser(response.user);
        this.changeAuthStatus(true);
        return true;
      }),
      catchError(err => {
        return of(false);
      })
    );
  }

  setLoginProcess(info:LoginProcessInfo) {
    this.loginProcessSubject.next(info);
  }

  getLoginProcess() {
    return this.loginProcessSubject.value;
  }

  resetLoginProcess() {
    this.loginProcessSubject.next(null as any);
  }

  private changeAuthStatus(value:boolean) {
    if(value==true) this.resetLoginProcess();
    this.loggedIn.next(value);
  }
}

interface LoginProcessInfo {
  signature_request_uuid:string;
  signatory_uuid:string;
  name:string;
  company:Company;
  email:string;
  phone:string;
}
